/* eslint-disable import/prefer-default-export */

export { default as CodeBlock } from './components/CodeBlock.vue';
